import Auth from "../services/AuthCentral/AuthService";
import { switchClient } from "../services/Management/UserProfileService";

export const USER_AUTHENTICATED = "USER_AUTHENTICATED";
export const authenticateUser = (
  username,
  password,
  isExternal,
  externalAuthenticationType,
  additionalSignInParams
) => {
  return (dispatch) => {
    Auth.authenticate(
      username,
      password,
      isExternal,
      externalAuthenticationType,
      additionalSignInParams,
      (Auth) => {
        dispatch({
          type: USER_AUTHENTICATED,
          payload: {
            isAuthenticated: Auth.isAuthenticated,
            redirectTo2FA: Auth.redirectTo2FA,
            twoFAuthType: Auth.twoFAuthType,
            twoFATOTPRequiresConfiguration: Auth.twoFATOTPRequiresConfiguration,
            ...(Auth.isAuthenticated ? Auth.userDetails : {}),
          },
        });
      }
    );
  };
};

export const signIn2FA = (signInUserWith2FAParameters) => {
  return (dispatch) => {
    Auth.signIn2FA(signInUserWith2FAParameters, (Auth) => {
      dispatch({
        type: USER_AUTHENTICATED,
        payload: {
          isAuthenticated: Auth.isAuthenticated,
          redirectTo2FA: false,
          ...(Auth.isAuthenticated ? Auth.userDetails : {}),
        },
      });
    });
  };
};

export const signInWithAccessToken = (token, cb) => {
  return async (dispatch) => {
    await Auth.signInWithAccessToken(token, (Auth) => {
      if (cb) cb(Auth.isAuthenticated);
      dispatch({
        type: USER_AUTHENTICATED,
        payload: {
          isAuthenticated: Auth.isAuthenticated,
          ...(Auth.isAuthenticated ? Auth.userDetails : {}),
        },
      });
    });
  };
};

export const USER_SIGNED_OUT = "USER_SIGNED_OUT";

export const signoutUser = () => {
  return (dispatch) => {
    if (localStorage.getItem("token")) {
      return Auth.signout()
        .then((res) => {
          localStorage.removeItem("token");
          dispatch({
            type: USER_SIGNED_OUT,
            payload: {},
          });
        })
        .catch((err) => {
          localStorage.removeItem("token");
          dispatch({
            type: USER_SIGNED_OUT,
            payload: {},
          });
        });
    } else {
      dispatch({
        type: USER_SIGNED_OUT,
        payload: {},
      });
    }
  };
};

export const CLOSE_ANNOUNCEMENT = "CLOSE_ANNOUNCEMENT";
export const closeAnnouncement = () => {
  return (dispatch) => {
    dispatch({
      type: CLOSE_ANNOUNCEMENT,
      payload: { ShowAnnouncement: false },
    });
  };
};

export const switchClientAuth = (clientId) => {
  return (dispatch) => {
    switchClient(clientId).then(() => {
      Auth.generateNewToken((Auth) =>
        dispatch({
          type: USER_AUTHENTICATED,
          payload: {
            isAuthenticated: Auth.isAuthenticated,
            ...(Auth.isAuthenticated ? Auth.userDetails : {}),
          },
        })
      );
    });
  };
};

export const UPDATE_USER_LANG = "UPDATE_USER_LANG";
export const updateUserLang = (language) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_USER_LANG,
      payload: { language },
    });
  };
};
export default {
  USER_AUTHENTICATED,
  USER_SIGNED_OUT,
  CLOSE_ANNOUNCEMENT,
  UPDATE_USER_LANG,
  authenticateUser,
  signoutUser,
  closeAnnouncement,
  signInWithAccessToken,
  switchClientAuth,
  updateUserLang,
  signIn2FA,
};
